import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import {
  WrenchScrewdriverIcon,
  CubeIcon,
  PuzzlePieceIcon,
  RocketLaunchIcon,
} from '@heroicons/react/24/outline';

const CustomSoftware = () => {
  const serviceData = {
    icon: WrenchScrewdriverIcon,
    title: 'Custom Software',
    description: 'Bespoke software solutions and applications designed specifically for your business requirements, workflows, and unique challenges to drive efficiency and growth.',
    gradient: 'from-green-900 to-green-700',
    technologies: [
      'React & Vue.js',
      'Node.js & Python',
      'Mobile Development',
      'Desktop Applications',
      'API Integration',
      'Database Systems',
    ],
    features: [
      {
        icon: CubeIcon,
        title: 'Custom Applications',
        description: 'Tailored applications built specifically for your business needs.',
      },
      {
        icon: PuzzlePieceIcon,
        title: 'System Integration',
        description: 'Seamless integration with your existing systems and workflows.',
      },
      {
        icon: RocketLaunchIcon,
        title: 'Scalable Solutions',
        description: 'Software that grows with your business and adapts to new requirements.',
      },
    ],
    services: [
      'Custom Application Development',
      'Legacy System Modernization',
      'API Development & Integration',
      'Mobile App Development',
      'Desktop Software Solutions',
      'Workflow Automation',
      'Software Maintenance & Support',
      'Quality Assurance & Testing',
    ],
    whyChoose: [
      'Tailored to Your Specific Needs',
      'Modern Development Practices',
      'Ongoing Support & Maintenance',
      'Scalable & Future-Proof Solutions',
    ],
  };

  return <ServiceTemplate {...serviceData} />;
};

export default CustomSoftware;
